import { ICustomIconProps } from './types';

const IconDocumentText: React.FC<ICustomIconProps> = ({ size = 20, color = '#269ECC' }) => (
  <svg width={size} height={size} viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M13.1667 18.1579C12.8251 18.4996 12.2334 18.2663 12.2334 17.7913V14.8829C12.2334 13.6663 13.2667 12.6579 14.5251 12.6579C15.3167 12.6496 16.4167 12.6496 17.3584 12.6496C17.8334 12.6496 18.0834 13.2079 17.7501 13.5413C16.5501 14.7496 14.4001 16.9246 13.1667 18.1579Z'
      fill='#269ECC'
    />
    <path
      d='M17.083 11.508H14.6747C12.6997 11.508 11.0913 13.1163 11.0913 15.0913V17.4997C11.0913 17.958 10.7163 18.333 10.258 18.333H6.72467C4.15801 18.333 2.08301 16.6663 2.08301 13.6913V6.30801C2.08301 3.33301 4.15801 1.66634 6.72467 1.66634H13.2747C15.8413 1.66634 17.9163 3.33301 17.9163 6.30801V10.6747C17.9163 11.133 17.5413 11.508 17.083 11.508ZM9.58301 5.20801H6.24967C5.90801 5.20801 5.62467 5.49134 5.62467 5.83301C5.62467 6.17467 5.90801 6.45801 6.24967 6.45801H9.58301C9.92467 6.45801 10.208 6.17467 10.208 5.83301C10.208 5.49134 9.92467 5.20801 9.58301 5.20801ZM11.2497 8.54134H6.24967C5.90801 8.54134 5.62467 8.82467 5.62467 9.16634C5.62467 9.50801 5.90801 9.79134 6.24967 9.79134H11.2497C11.5913 9.79134 11.8747 9.50801 11.8747 9.16634C11.8747 8.82467 11.5913 8.54134 11.2497 8.54134Z'
      fill={color}
    />
  </svg>
);

export default IconDocumentText;
